









import Vue from 'vue';
import { Icon } from '../../../../basic';

export default Vue.extend({
  name: 'DropdownIndicator',
  components: {Icon},
  props: {
    hasIcon: {
      type: Boolean,
      default: true,
    },
    activeIcon: {
      type: String,
    },
    inactiveIcon: {
      type: String,
    },
    iconSize: {
      type: Number,
      default: 24,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconName() {
      return this.isActive ? this.activeIcon : this.inactiveIcon;
    },
  },
});
